import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faPenToSquare,faMultiply,faSave, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ButtonOverride from "../../../../../components/buttonoverride";
import styles from '../../../../../styles/fileupload.module.css';
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { EmptyStringToNull, PrepareNullableDataForSend } from "../../../../../utilities/rhfdatanormalizationfunctions";

const smallAddButtonStyle = {
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    minHeight: "32px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const BidQuickAdd = ({ActionTypes = [],prepend}) => {
    const [bidUpload,setBidUpload] = useState(null);
    const [checkUpload,setCheckUpload] = useState(null);

    const bidRef = useRef(null);
    const checkRef = useRef(null);

    const _handleBidFileClick = () => {
        if(bidRef?.current){
            bidRef.current.click();
        }
    }

    const _handleBidFileChange = (e) => {
        setBidUpload(e.target.files[0]);

        bidRef.current.value = '';
    }

    const _handleCheckFileClick = () => {
        if(checkRef?.current){
            checkRef.current.click();
        }
    }

    const _handleCheckFileChange = (e) => {
        setCheckUpload(e.target.files[0]);

        checkRef.current.value = '';
    }

    const initialValues = {
        amount: 0.00,
        action: '',
        comments: '',
        finalamount: 0.00
    }

    const {handleSubmit,register,control,watch,resetField,reset,setValue,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const _handleSubmit = (values) => {
        const insertVal = {
            id: crypto.randomUUID(),
            bidupload: bidUpload,
            checkupload: checkUpload,
            lastmodifiedby: null,
            lastmodifieddate: null,
            ...values
        };

        const sendVal = PrepareNullableDataForSend(insertVal);

        prepend(sendVal);

        setBidUpload(null);
        setCheckUpload(null);
        reset(initialValues);
    }

    return(
        <tr>
            <td className="align-middle">
                {
                        bidUpload
                        ?
                            <div className='d-flex align-items-center'>
                                <a href={URL.createObjectURL(bidUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                    View File
                                </a>
                                <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setBidUpload(null)}>
                                    <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                </ButtonOverride>
                            </div>
                        :
                            <Button id="bidupload" type="button" variant="success" onClick={_handleBidFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                }
                <input ref={bidRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleBidFileChange}/>
            </td>
            <td className="align-middle">
                <Controller
                    name='amount'
                    control={control}
                    render={({ field }) => (
                        <NumericFormat
                            value={field.value} 
                            id='bidamound'
                            placeholder="Bid Amount" 
                            style={{ width: '100%', height: '32px' }} 
                            prefix={'$'} 
                            decimalScale={2} 
                            fixedDecimalScale={true} 
                            allowNegative={false}
                            onValueChange={(values) => {
                                if(values.floatValue === undefined || values.floatValue === null){
                                    field.onChange(null); //Reset to default
                                }
                                else{
                                    field.onChange(values.floatValue);
                                }
                            }}
                        />
                    )}
                />
            </td>
            <td className="align-middle">
                {
                    ActionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register(`action`)} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                {
                        checkUpload
                        ?
                            <div className='d-flex align-items-center'>
                                    <a href={URL.createObjectURL(checkUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                        View File
                                    </a>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setCheckUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                        :
                            <Button id="bidupload" type="button" variant="success" onClick={_handleCheckFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                }
                <input ref={checkRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleCheckFileChange}/>
            </td>
            <td className="align-middle">
                <Controller
                    name={`finalamount`}
                    control={control}
                    render={({ field }) => (
                        <NumericFormat 
                            value={field.value} 
                            id={`finalamount`}
                            placeholder="Final Amount" 
                            style={{ width: '100%', height: '32px' }} 
                            prefix={'$'} 
                            decimalScale={2} 
                            fixedDecimalScale={true} 
                            allowNegative={false}
                            onValueChange={(values) => {
                                if(values.floatValue === undefined || values.floatValue === null){
                                    field.onChange(null); //Reset to default
                                }
                                else{
                                    field.onChange(values.floatValue);
                                }
                            }} 
                        />
                    )}
                />
            </td>
            <td className="align-middle">
                <textarea rows={2} placeholder="Comments" {...register(`comments`)} />
            </td>
            <td className="align-middle"></td>
            <td className="align-middle"></td>
            <td className="align-middle">
                <div className="d-flex align-items-center">
                    <Button type="button" variant="primary" onClick={handleSubmit(_handleSubmit)}>
                        Insert
                    </Button>
                </div>
            </td>
        </tr>
    )
}

export default BidQuickAdd;
